<div>

  <div>
    <iui-messages #messages class="ms-auto me-auto"></iui-messages>
  </div>

  <form (keydown.enter)="handleEnterKeyPress($event)" #form="ngForm" name="form" (ngSubmit)="submit(form)">
    <h4>Create New Linked Account</h4>

    <h5 class="mt-4 ">Linked Account Organization Information </h5>

    <div class="row mt-3">
      <label for="company" class="required">Organization Name</label>
      <div class="col-6">
        <input appScrText [(ngModel)]="model.account.company" #company="ngModel" name="company" id="company" placeholder="Organization Name" maxlength="{{MaxLen.Company}}" required />
        <app-error-msg [form]="form" fieldName="company" [field]="company" ></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <label for="companyUrl" class="required">Organization URL</label>
      <div class="col-6">
        <input appScrText appUrlValidator [(ngModel)]="model.account.companyUrl" name="companyUrl" id="companyUrl" #companyUrl="ngModel" placeholder="Organization URL"
          maxlength="{{MaxLen.CompanyUrl}}" required />
        <app-error-msg [form]="form" [field]="companyUrl" fieldLabel="Organization URL"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <label for="fein" class="required">Federal Tax ID (##-#######)</label>
      <div class="col-4">
        <input appScrText [(ngModel)]="model.account.fein" #fein="ngModel" name="fein" id="fein" mask="00-0000000" [dropSpecialCharacters]="false" placeholder="**-*******"
          required />
        <app-error-msg [form]="form" [field]="fein" fieldLabel="Federal Tax ID"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <label for="linkedAccountName" class="required">Linked Account Name</label>
      <div class="col-6">
        <input appScrText [(ngModel)]="model.account.linkedAccountName" #linkedAccountName="ngModel" name="linkedAccountName" id="linkedAccountName"
          placeholder="A Nickname for this Linked Account" maxlength="{{MaxLen.Company}}" required />
        <app-error-msg [form]="form" [field]="linkedAccountName" fieldLabel="Linked Account Name"></app-error-msg>
      </div>
    </div>


    <h5 i18n class="mt-5">Linked Account Primary Account Contact</h5>

    <div class="row mt-3">
      <div class="col-3">
        <label for="accountFirstName" class="required">First Name</label>
        <input appScrText appFirstNameValidator [(ngModel)]="model.account.firstName" #accountFirstName="ngModel" name="accountFirstName" id="accountFirstName"
          placeholder="First Name" maxlength="{{MaxLen.FirstName}}" required />

        <app-error-msg [form]="form" [field]="accountFirstName" fieldLabel="First Name"></app-error-msg>
      </div>

      <div class="col-3">
        <label for="accountLastName" class="required">Last Name</label>
        <input appScrText appLastNameValidator [(ngModel)]="model.account.lastName" #accountLastName="ngModel" name="accountLastName" id="accountLastName" placeholder="Last Name"
          maxlength="{{MaxLen.LastName}}" required />

        <app-error-msg [form]="form" [field]="accountLastName" fieldLabel="Last Name"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-2">
        <label for="accountPhoneInput" class="required">Phone Number</label>
        <app-phone [(ngModel)]="model.account.phone" #accountPhone="ngModel" class="col-12" name="accountPhone" required id="accountPhone"></app-phone>
        <app-error-msg [form]="form" [field]="accountPhone" fieldLabel="Phone Number"></app-error-msg>
      </div>
      <div class="col-1 ps-0">
        <label for="accountPhoneExtension">Extension</label>
        <input appScrText [(ngModel)]="model.account.phoneExtension" maxlength="{{MaxLen.PhoneExtension}}" name="accountPhoneExtension" id="accountEPhonExtension" placeholder="" />
      </div>

      <div class="col-3">
        <label for="accountEmail" class="required">Email</label>
        <input appEmail appEmailValidator [(ngModel)]="model.account.email" name="accountEmail" id="accountEmail" #accountEmail="ngModel" maxlength="{{MaxLen.Email}}"
          placeholder="Email" required />
        <app-error-msg [form]="form" [field]="accountEmail" fieldLabel="Email"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <label for="accountCountry" class="required" for="country">Country</label>
      <div class="col-3">
        <app-country-dropdown [(ngModel)]="model.account.country" name="accountCountry" #accountCountry="ngModel"
         id="accountCountry"></app-country-dropdown>
        <app-error-msg [form]="form" [field]="accountCountry" fieldLabel="Country"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <label for="accountAddress1" class="required">Organization Address 1</label>
      <div class="col-6">
        <input appScrText [(ngModel)]="model.account.address1" #accountAddress1="ngModel" name="accountAddress1" id="accountAddress1" placeholder="Organization Address 1"
          maxlength="{{MaxLen.Address}}" required />
        <app-error-msg [form]="form" [field]="accountAddress1" fieldLabel="Organization Address 1"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6 ">
        <label for="accountAddress2">Organization Address 2</label>
        <input appScrText [(ngModel)]="model.account.address2" #accountAddress2="ngModel" name="accountAddress2" id="accountAddress2" placeholder="Organization Address 2"
          maxlength="{{MaxLen.Address}}" />
        <app-error-msg [form]="form" [field]="accountAddress2" fieldLabel="Organization Address 2"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-2 ">
        <label for='accountCity' class="required">City</label>
        <input appScrText [(ngModel)]="model.account.city" #accountCity="ngModel" name="accountCity" id="accountCity" placeholder="City" maxlength="{{MaxLen.City}}" required />

        <app-error-msg [form]="form" [field]="accountCity" fieldLabel="City"></app-error-msg>
      </div>

      <div class="col-2">
        <label for="accountState" [ngClass]="{required: model.account.country === 'ca' || model.account.country === 'us'}">State/Province</label>
        <app-region-dropdown name="accountState" id="accountState" [(ngModel)]="model.account.state" #accountState="ngModel" [country]="model.account.country">
        </app-region-dropdown>
        <app-error-msg [form]="form" [field]="accountState" fieldLabel="State/Province"></app-error-msg>
      </div>

      <div class="col-2">
        <label for="accountZipInput" [ngClass]="{required: model.account.country === 'us' || model.account.country === 'ca'}">Zip/Postal Code</label>
        <app-zipcode-input name="accountZip" id="accountZip" inputId="accountZipInput" [(ngModel)]="model.account.zip" [country]="model.account.country"
         #accountZip="ngModel"></app-zipcode-input>

        <app-error-msg [form]="form" [field]="accountZip" fieldLabel="Zip/Postal Code"></app-error-msg>
      </div>
    </div>

    <!-- User Info -->
    <h5 i18n class="mt-5">Linked Account User</h5>

    <div class="row mt-3">
      <div class="col-3">
        <label for="userFirstName" class="required">First Name</label>
        <input appScrText appFirstNameValidator [(ngModel)]="model.user.firstName" #userFirstName="ngModel" name="userFirstName" id="userFirstName"
          placeholder="First Name" maxlength="{{MaxLen.FirstName}}" required />

        <app-error-msg [form]="form" [field]="userFirstName" fieldLabel="First Name"></app-error-msg>
      </div>

      <div class="col-3">
        <label for="userLastName" class="required">Last Name</label>
        <input appScrText appLastNameValidator [(ngModel)]="model.user.lastName" #userLastName="ngModel" name="userLastName" id="userLastName" placeholder="Last Name"
          maxlength="{{MaxLen.LastName}}" required />

        <app-error-msg [form]="form" [field]="userLastName" fieldLabel="Last Name"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-3">
        <label for="userPhone" class="required">Phone Number</label>
        <app-phone [(ngModel)]="model.user.phone" #userPhone="ngModel" class="col-12" name="userPhone" required id="userPhone"></app-phone>
        <app-error-msg [form]="form" [field]="userPhone" fieldLabel="Phone Number"></app-error-msg>
      </div>
      <div class="col-3">
        <label for="userExtension">Extension</label>
        <input appScrText [(ngModel)]="model.user.phoneExtension" maxlength="{{MaxLen.PhoneExtension}}" name="userExtension" id="userExtension" placeholder="" />
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-3">
        <label for="userEmail" class="required">Email</label>
        <input appEmail appEmailValidator [(ngModel)]="model.user.email" name="userEmail" id="userEmail" #userEmail="ngModel" maxlength="{{MaxLen.Email}}"
          placeholder="Email" required />
        <app-error-msg [form]="form" [field]="userEmail" fieldLabel="Email"></app-error-msg>
      </div>

      <div class="col-3">
        <label for="userConfirmEmail" class="required">Confirm Email Address</label>
        <input #userConfirmEmail="ngModel" appEmail appEmailValidator [(ngModel)]="model.user.confirmEmail" name="userConfirmEmail" placeholder="Confirm Email Address"
          id="userConfirmEmail" required maxlength="{{MaxLen.Email}}" [appExactMatch]="userEmail"/>
        <app-error-msg [form]="form" [field]="userConfirmEmail" fieldName="userConfirmEmail" otherFieldLabel="Email"></app-error-msg>
      </div>
    </div>


    <div class="row mt-2">
      <label for="userCountry" class="required">Country</label>
      <div class="col-3">
        <app-country-dropdown [(ngModel)]="model.user.country" name="userCountry" #userCountry="ngModel" id="userCountry"></app-country-dropdown>
        <app-error-msg [form]="form" [field]="userCountry" fieldLabel="Country"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <label for="userAddress1" class="required">Organization Address 1</label>
      <div class="col-6">
        <input appScrText [(ngModel)]="model.user.address1" #userAddress1="ngModel" name="userAddress1" id="userAddress1" placeholder="Organization Address 1"
          maxlength="{{MaxLen.Address}}" required />
        <app-error-msg [form]="form" [field]="userAddress1" fieldLabel="Organization Address 1"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6 ">
        <label for="userAddress2">Organization Address 2</label>
        <input appScrText [(ngModel)]="model.user.address2" #userAddress2="ngModel" name="userAddress2" id="userAddress2" placeholder="Organization Address 2"
          maxlength="{{MaxLen.Address}}" />
        <app-error-msg [form]="form" [field]="userAddress2" fieldLabel="Organization Address 2"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-2 ">
        <label for='userCity' class="required">City</label>
        <input appScrText [(ngModel)]="model.user.city" #userCity="ngModel" name="userCity" id="userCity" placeholder="City" maxlength="{{MaxLen.City}}" required />

        <app-error-msg [form]="form" [field]="userCity" fieldLabel="City"></app-error-msg>
      </div>

      <div class="col-2">
        <label for="userState" [ngClass]="{required: model.user.country === 'ca' || model.user.country === 'us'}">State/Province</label>
        <app-region-dropdown name="userState" id="userState" [(ngModel)]="model.user.state" #userState="ngModel" [country]="model.user.country">
        </app-region-dropdown>
        <app-error-msg [form]="form" [field]="userState" fieldLabel="State/Province"></app-error-msg>
      </div>

      <div class="col-2">
        <label for="userZipInput" [ngClass]="{required: model.user.country === 'us' || model.user.country === 'ca'}">Zip/Postal Code</label>
        <app-zipcode-input name="userZip" id="userZip" inputId="userZipInput" [(ngModel)]="model.user.zip" [country]="model.user.country" 
        #userZip="ngModel"></app-zipcode-input>

        <app-error-msg [form]="form" [field]="userZip" fieldLabel="Zip/Postal Code"></app-error-msg>
      </div>
    </div>




    <!-- Billing Info -->
    <h5 i18n class="mt-5">Linked Account Billing Contact</h5>

    <div class="row">
      <div class="col-12">
        <button type="button" class="btn btn-primary" (click)="copyBillingFromUser()">Copy from Linked Account User</button>
        <button type="button" class="btn btn-primary ms-2" (click)="copyBillingFromContact()">Copy from Linked Primary Account Contact</button>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-3">
        <label for="accountBillingFirstName" class="required">First Name</label>
        <input appScrText appFirstNameValidator [(ngModel)]="model.account.billingFirstName" #accountBillingFirstName="ngModel" name="accountBillingFirstName" id="accountBillingFirstName"
          placeholder="First Name" maxlength="{{MaxLen.FirstName}}" required />

        <app-error-msg [form]="form" [field]="accountBillingFirstName" fieldLabel="First Name"></app-error-msg>
      </div>

      <div class="col-3">
        <label for="accountBillingLastName" class="required">Last Name</label>
        <input appScrText appLastNameValidator [(ngModel)]="model.account.billingLastName" #accountBillingLastName="ngModel" name="accountBillingLastName" id="accountBillingLastName" placeholder="Last Name"
          maxlength="{{MaxLen.LastName}}" required />

        <app-error-msg [form]="form" [field]="accountBillingLastName" fieldLabel="Last Name"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-2">
        <label for="accountBillingPhone" class="required">Phone Number</label>
        <app-phone [(ngModel)]="model.account.billingPhone" #accountBillingPhone="ngModel" class="col-12" name="accountBillingPhone" required id="accountBillingPhone"></app-phone>
        <app-error-msg [form]="form" [field]="accountBillingPhone" fieldLabel="Phone Number"></app-error-msg>
      </div>
      <div class="col-1 ps-0">
        <label for="accountBillingExtension">Extension</label>
        <input appScrText [(ngModel)]="model.account.billingPhoneExtension" maxlength="{{MaxLen.PhoneExtension}}" name="accountBillingExtension" id="accountBillingExtension" placeholder="" />
      </div>

      <div class="col-3">
        <label for="accountBillingEmail" class="required">Email</label>
        <input appEmail appEmailValidator [(ngModel)]="model.account.billingEmail" name="accountBillingEmail" id="accountBillingEmail" #accountBillingEmail="ngModel" maxlength="{{MaxLen.Email}}"
          placeholder="Email" required />
        <app-error-msg [form]="form" [field]="accountBillingEmail" fieldLabel="Email"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <label for="accountBillingCountry" class="required" for="country">Country</label>
      <div class="col-3">
        <app-country-dropdown [(ngModel)]="model.account.billingCountry" name="accountBillingCountry" #accountBillingCountry="ngModel"
         id="accountBillingCountry"></app-country-dropdown>
        <app-error-msg [form]="form" [field]="accountBillingCountry" fieldLabel="Country"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <label for="accountBillingAddress1" class="required">Organization Address 1</label>
      <div class="col-6">
        <input appScrText [(ngModel)]="model.account.billingAddress1" #accountBillingAddress1="ngModel" name="accountBillingAddress1" id="accountBillingAddress1" placeholder="Organization Address 1"
          maxlength="{{MaxLen.Address}}" required />
        <app-error-msg [form]="form" [field]="accountBillingAddress1" fieldLabel="Organization Address 1"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-6 ">
        <label for="accountBillingAddress2">Organization Address 2</label>
        <input appScrText [(ngModel)]="model.account.billingAddress2" #accountBillingAddress2="ngModel" name="accountBillingAddress2" id="accountBillingAddress2" placeholder="Organization Address 2"
          maxlength="{{MaxLen.Address}}" />
        <app-error-msg [form]="form" [field]="accountBillingAddress2" fieldLabel="Organization Address 2"></app-error-msg>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-2 ">
        <label for='accountBillingCity' class="required">City</label>
        <input appScrText [(ngModel)]="model.account.billingCity" #accountBillingCity="ngModel" name="accountBillingCity" id="accountBillingCity" placeholder="City" maxlength="{{MaxLen.City}}" required />

        <app-error-msg [form]="form" [field]="accountBillingCity" fieldLabel="City"></app-error-msg>
      </div>

      <div class="col-2">
        <label for="accountBillingState" [ngClass]="{required: model.account.billingCountry === 'ca' || model.account.billingCountry === 'us'}">State/Province</label>
        <app-region-dropdown name="accountBillingState" id="accountBillingState" [(ngModel)]="model.account.billingState" #accountBillingState="ngModel" [country]="model.account.billingCountry">
        </app-region-dropdown>
        <app-error-msg [form]="form" [field]="accountBillingState" fieldLabel="State/Province"></app-error-msg>
      </div>

      <div class="col-2">
        <label for="accountBillingZipInput" [ngClass]="{required: model.account.billingCountry === 'us' || model.account.billingCountry === 'ca'}">Zip/Postal Code</label>
        <app-zipcode-input name="accountBillingZip" id="accountBillingZip" inputId="accountBillingZipInput" [(ngModel)]="model.account.billingZip" [country]="model.account.billingCountry" 
        #accountBillingZip="ngModel">
        </app-zipcode-input>
        <app-error-msg [form]="form" [field]="accountBillingZip" fieldLabel="Zip/Postal Code"></app-error-msg>
      </div>
    </div>

    <div class="row mt-4">
      <button class="col-auto btn btn-primary  px-4 mb-2" submit>Create Account</button>
      <button class="col-auto btn btn-secondary px-4 mb-2 ms-2" type="button" (click)="cancelCreateNewLinkedAccount()">Cancel</button>
    </div>

  </form>
</div>

<p-confirmDialog key='confirmCancel' #laConfirm width="425" [closable]="false">
  <p-footer>
    <button i18n id="laaccept" class="btn btn-primary me-2" type="button" (click)="laConfirm.accept()">Yes</button>
    <button i18n id="lareject" class="btn btn-secondary" type="button" (click)="laConfirm.reject()">No</button>
  </p-footer>
</p-confirmDialog>